<template>
  <div class="about">
    <h1>The best gaming streaming</h1>
  </div>
</template>
